export const DEFAULT_AVATAR_TYPES = {
  AI_AGENT: 'AI_AGENT',
  CAMPAIGN: 'CAMPAIGN',
  CONTACT: 'CONTACT',
  COMPANIES: 'COMPANIES',
  PRODUCT: 'PRODUCT',
  TICKET: 'TICKET',
  DEAL: 'DEAL',
  MARKETING_EVENT: 'MARKETING_EVENT'
};
const CONTACT_DEFINITION = {
  defaultAvatarType: DEFAULT_AVATAR_TYPES.CONTACT,
  requiresPortalId: false
};
const CONTACT_RECORD_DEFINITION = Object.assign({}, CONTACT_DEFINITION, {
  requiresPortalId: true,
  objectTypeId: '0-1'
});
const COMPANY_DEFINITION = {
  defaultAvatarType: DEFAULT_AVATAR_TYPES.COMPANIES,
  requiresPortalId: false
};
const COMPANY_RECORD_DEFINITION = Object.assign({}, COMPANY_DEFINITION, {
  requiresPortalId: true,
  objectTypeId: '0-2'
});
const AVATAR_TYPE_DEFINITIONS = {
  // AI Agents
  'ai-agent': {
    defaultAvatarType: DEFAULT_AVATAR_TYPES.AI_AGENT,
    requiresPortalId: false
  },
  // Campaigns
  campaign: {
    defaultAvatarType: DEFAULT_AVATAR_TYPES.CAMPAIGN,
    requiresPortalId: false
  },
  // Companies
  company: COMPANY_RECORD_DEFINITION,
  companyId: COMPANY_RECORD_DEFINITION,
  domain: COMPANY_DEFINITION,
  enrichmentDomain: COMPANY_DEFINITION,
  // Contacts
  contact: CONTACT_RECORD_DEFINITION,
  email: CONTACT_DEFINITION,
  emails: CONTACT_DEFINITION,
  enrichmentEmail: CONTACT_DEFINITION,
  hubSpotUserEmail: CONTACT_DEFINITION,
  hubSpotUserEmails: CONTACT_DEFINITION,
  vid: CONTACT_RECORD_DEFINITION,
  // Deals
  deal: {
    defaultAvatarType: DEFAULT_AVATAR_TYPES.DEAL,
    requiresPortalId: false
  },
  // Products
  productId: {
    defaultAvatarType: DEFAULT_AVATAR_TYPES.PRODUCT,
    requiresPortalId: true,
    objectTypeId: '0-7'
  },
  // Tickets
  ticket: {
    defaultAvatarType: DEFAULT_AVATAR_TYPES.TICKET,
    requiresPortalId: false
  },
  // Marketing Events
  marketingEventId: {
    defaultAvatarType: DEFAULT_AVATAR_TYPES.MARKETING_EVENT,
    requiresPortalId: true,
    objectTypeId: '0-54'
  }
};
export const AVATAR_TYPES = Object.fromEntries(Object.entries(AVATAR_TYPE_DEFINITIONS).map(([type, definition]) => [type, definition.defaultAvatarType]));
export function resolveAvatarType(type) {
  if (typeof type !== 'string' || !Object.prototype.hasOwnProperty.call(AVATAR_TYPE_DEFINITIONS, type)) {
    return undefined;
  }
  return AVATAR_TYPE_DEFINITIONS[type];
}